module.exports = __webpack_public_path__ + "media/images/beauty/agathe@3x-ea42d61b7e5f4bb00f8e7b00d61782b1.jpg";